// EL BORRADOR DEL CUESTIONARIO RETOMA POR EL NOMBRE DE LA PANTALLA, NO POR SU NÚMERO (18-10).
//
// El borrador guardaba solo el número de pantalla. El rediseño del onboarding quitó seis
// («Empecemos», las cuatro portadas y el día tipo) y quien volvía con uno a medias caía
// hasta seis preguntas más allá: el que lo dejó en «¿Cuántas comidas…?» volvía en «¿Cómo
// me has conocido?» y se saltaba las alergias. Ahora se guarda la clave de la pantalla
// (`key` o, si no tiene, `type`, la misma firma que usa el cuestionario para saber si el
// recorrido cambió) y cuántas iguales hay antes en la lista. Lo guarda
// `PUT /clients/ajuste-progreso` (`backend/core/progreso_del_cuestionario.py`).

export const claveDePantalla = (paso) => (paso && (paso.key || paso.type)) || null;

// Lo que se guarda del paso `i` de `flow`: { pantalla, vez }.
export function pantallaParaGuardar(flow, i) {
    const pantalla = claveDePantalla(flow?.[i]);
    if (!pantalla) return { pantalla: null, vez: 0 };
    let vez = 0;
    for (let j = 0; j < i; j++) if (claveDePantalla(flow[j]) === pantalla) vez++;
    return { pantalla, vez };
}

// La pantalla a la que lleva «Atrás»: la última visible antes de `i`, o -1 si no hay ninguna.
// Delante de la primera pregunta del largo puede haber pantallas ocultas (31-10): el botón se
// veía y no llevaba a ningún sitio.
export function pantallaAnterior(flow, i, visible) {
    for (let j = i - 1; j >= 0; j--) if (flow[j] && visible(flow[j])) return j;
    return -1;
}

// Si hay que esperar a colocar el borrador del largo antes de enseñar una pregunta (31-10).
// Quien vuelve de pagar ve antes «Pago confirmado», que es lo que da paso a colocarlo, y en
// revisión no se retoma nada: en esos casos esperar sería no salir nunca.
export function esperaElBorrador({ retomandoNivel1, revision, pagoRevisado, pagoConfirmado,
                                   borradorColocado, flujoGuardado }) {
    return !!retomandoNivel1 && !revision && !pagoRevisado && !pagoConfirmado
        && !borradorColocado && flujoGuardado === 'nivel1';
}

// El número de paso donde retomar. Un borrador sin nombre de pantalla (los de antes del
// 18-10) vale por su número solo en el ajuste, cuya lista no cambió con el rediseño; los
// del alta estaban numerados sobre otra lista y empiezan por el principio, con sus
// respuestas puestas pero sin saltarse ninguna pregunta. Igual si la pantalla ya no está.
export function pasoDelBorrador(flow, guardado) {
    const pantalla = guardado?.pantalla;
    if (!Array.isArray(flow)) return 0;
    if (!pantalla) return guardado?.flujo === 'ajuste' ? (Number(guardado.paso) || 0) : 0;
    const vez = Number(guardado.vez) || 0;
    let vistas = 0;
    for (let j = 0; j < flow.length; j++) {
        if (claveDePantalla(flow[j]) !== pantalla) continue;
        if (vistas === vez) return j;
        vistas++;
    }
    return 0;
}
